/* eslint-disable max-classes-per-file */
export class SaveNewMenuState {
  static readonly type = '[Menu List] Save New Menu State';
  constructor(public url: string) {}
}
